enum ConditionScope {
  CONTACT = 'CONTACT',
  EVENTS = 'EVENTS',
  AUTOMATION_EVENTS = 'AUTOMATION_EVENTS',
  AUTOMATION_CONTEXT = 'AUTOMATION_CONTEXT'
}

export default ConditionScope
